import React from "react";
import { makeStyles } from "@material-ui/core";


let useStyles = makeStyles((theme) => ({
    gridInfo: {
        // width: 320,
        // width: '24%',
        padding: '20px 20px'
    },
    logo: {
        width: 211,
        filter: 'grayscale(1)',
        position: 'relative',
        top: '-10px',
        '&:hover': {
            filter: 'grayscale(0)',
        }
    },
    gridContent: {
        marginBottom: 10,
    },

    lineTel: {
        padding: '0px 5px'
    },
    icon: {
        width: '25px !important',
        marginLeft: 11,
        fill: "#0B1742",
        height: 25,
    },
    gridTel: {
        display:'flex',
        "@media(max-width : 1181px)":{
           flexDirection:'column'
        },
        "@media(max-width : 950px)":{
            flexDirection:'row',
         },
         "@media(max-width : 356px)":{
            flexDirection:'column'
         },
        // whiteSpace: "nowrap",
    },
    contentTell:{
        "@media(max-width : 1181px)":{
            marginTop:10,
         },
         "@media(max-width : 950px)":{
            marginTop:0,
         },
         "@media(max-width : 356px)":{
            marginTop:10,
         },
    }
}))

export default function Index({ BoldText }) {

    let classes = useStyles();

    const icons = {
        header: 'logo-pishro',
        list: [
            {
                iconSrc: 'telegram',
                link: 'https://t.me/pouyanbrokerage',
            },
            {
                iconSrc: 'instagram',
                link: 'https://www.instagram.com/pouyanbrokerage',
            },
            {
                iconSrc: 'aparat',
                link: 'https://www.aparat.com/pouyanbroker',
            },
            // {
            //     iconSrc: 'twiter',
            //     link: '#',
            // },

        ]
    }
    return (
        <div className={classes['gridInfo']}>
            <div>
                <img src={'/assets/images/logo.png'} className={classes['logo']} />
            </div>
            <div className={classes['gridContent']}>
                <span className={`${BoldText}`}>
                    آدرس :
                </span>
                <span>
                     {/* تهران، خیابان شهیدبهشتی، تقاطع خیابان قنبرزاده و
                    خیابان خرمشهر ،پلاک 222 ،طبقه اول */}
                    تهران، خیابان طالقانی بعد از تقاطع ولیعصر ،روبروی ساختمان بورس کالا، پلاک 440
                </span>
            </div>
            <div className={`${classes['gridTel']} ${classes['gridContent']}`}>
                <span className={`${BoldText}`}>
                    شماره‌های تماس:
                </span>
                <div className={classes['contentTell']}>
                    <span>

                        91005777
                        -
                        021
                    </span>
                    {/* <span className={classes['lineTel']}>
                        |
                    </span>
                    <span>
                        53782000
                        -
                        021
                    </span> */}
                </div>
            </div>
            <div>
                <p className={`${BoldText}`}>
                    پویان در شبکه‌های اجتماعی
                </p>
            </div>
            <div>
                {
                    icons.list.map((icon, index) => {
                        return (
                            <a href={icon.link} target={'_blank'}>
                                <svg key={index} style={{ width: 25 }} className={classes.icon} >
                                    <use xlinkHref={`/sprit.svg#${icon.iconSrc}`}></use>
                                </svg>
                            </a>

                        )
                    })
                }
            </div>
        </div>
    )
}
